import script from "./Pay.vue?vue&type=script&lang=ts&setup=true"
export * from "./Pay.vue?vue&type=script&lang=ts&setup=true"

import "./Pay.vue?vue&type=style&index=0&id=978cbf6a&lang=css"

const __exports__ = script;

export default __exports__